import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * A platform admin resets a company user's two-factor authentication. The
 * API refuses it outside the admin's own support session into the group, and
 * writes the audit row and the user's mail itself.
 */
export function useResetUserTwoFactor(groupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: { userId: string; reason: string }) => {
      await api.POST('/platform/groups/{group}/users/{user}/two-factor-reset', {
        params: { path: { group: groupId, user: input.userId } },
        body: { reason: input.reason },
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['platform', 'groups', groupId, 'users'] })
    },
  })
}
